import React from 'react';
import { Carousel } from 'flowbite-react';
import { product } from '../utils/sjt_product';

const ProductsSection = () => {
  return (
    <div className="h-56 sm:h-64 xl:h-80 2xl:h-96 max-w-2xl ml-auto mr-auto mb-10 ">
      <Carousel slideInterval={1000}>
        {product.map((item) => (
          <div
            key={item.id}
            className="flex flex-col items-center justify-center h-full"
          >
            <img
              src={item.img}
              alt={item.product_name}
              className="h-48 object-contain"
            />
            <h3 className="mt-4 text-xl font-semibold">{item.product_name}</h3>
            <p className=" text-gray-800">{item.type}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ProductsSection;
